import type { ComponentProps } from 'react';
import { OwcAssistiveText } from '@one/react';

export type PocAssistiveTextProps = ComponentProps<typeof OwcAssistiveText>;

export const PocAssistiveText: React.FC<PocAssistiveTextProps> = (props) => <OwcAssistiveText {...props} />;
